export var tryParseInt = function tryParseInt(n, radix) {
  try {
    return parseInt(n.toString(), radix);
  } catch (_) {
    return n;
  }
};
export var tryParseFloat = function tryParseFloat(n) {
  try {
    return parseFloat(n.toString());
  } catch (_) {
    return n;
  }
};